var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M512,126.621c0-21.177-17.167-38.345-38.345-38.345H38.345C17.167,88.276,0,105.443,0,126.621V256 h512V126.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M38.345,423.724h435.31c21.177,0,38.345-17.167,38.345-38.345V256H0v129.379 C0,406.557,17.167,423.724,38.345,423.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M235.904,182.293l6.036,18.097l19.076,0.148c1.478,0.011,2.091,1.898,0.902,2.775l-15.346,11.332 l5.754,18.188c0.446,1.409-1.159,2.574-2.361,1.716l-15.52-11.093l-15.52,11.093c-1.203,0.86-2.807-0.307-2.361-1.716l5.754-18.188 l-15.346-11.332c-1.188-0.878-0.576-2.764,0.902-2.775l19.076-0.148l6.036-18.097C233.453,180.89,235.436,180.89,235.904,182.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M317.487,335.944c0,0-109.206-82.385-112.43-85.092c-4.983-4.185-8.828-11.586-9.012-20.598 c0,0-11.777,12.064-9.471,24.552c2.667,14.436,10.943,19.586,21.61,26.574c7.496,4.911,67.087,42.495,101.875,64.419 L317.487,335.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M350.162,360.092c-1.423-1.016-12.861-9.47-28.73-21.227l-5.759,10.472 c11.651,7.341,19.409,12.227,19.409,12.227s1.103,14.345,12.69,11.955C351.948,372.655,355.31,363.77,350.162,360.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M255.863,322.053c-8.256,2.905-17.097,4.567-26.346,4.567c-23.442,0-44.445-10.212-58.987-26.36 l-12.928,11.635c4.333,4.812,8.96,9.347,14.175,13.217l-2.574,4.459l19.112,11.034l2.53-4.383 c8.634,3.755,17.916,6.282,27.638,7.383v5.084h22.069v-5.084c9.722-1.101,19.004-3.628,27.638-7.383l2.53,4.383l7.595-4.385 C270.899,331.543,263.3,326.749,255.863,322.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M325.951,236.138c-1.101-9.722-3.628-19.004-7.383-27.637l4.383-2.53l-11.034-19.113l-4.459,2.574 c-5.708-7.691-12.509-14.492-20.201-20.2l2.574-4.459l-19.112-11.034l-2.53,4.383c-7.163-3.115-14.788-5.327-22.723-6.639 l-2.9,17.404c37.656,6.237,66.4,38.862,66.4,78.286c0,21.228-8.377,40.465-21.942,54.717c4.692,3.543,9.35,7.059,13.953,10.535 c2.23-2.442,4.504-4.847,6.482-7.511l4.459,2.574l11.034-19.112l-4.383-2.53c3.755-8.634,6.282-17.916,7.383-27.637h5.083V236.14 h-5.084L325.951,236.138L325.951,236.138z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAo);
export default __webpack_public_path__ + "static/media/ao.98e54ec0b19057148398a1c3349d31da.svg";
export { ForwardRef as ReactComponent };